export default {"src":"/_next/static/media/manual-hero-bg.e8325143.svg","height":405,"width":439,"blurWidth":0,"blurHeight":0};